import React, { useState, useEffect } from "react";
import apiUrl from "../Apiurl";
import umanizzaDataSenzaSecondi from "./../interfaccia/funzioniComuni/umanizzaDataSenzaSecondi";
import associaImmagineENomeANomeUtente from "./../interfaccia/funzioniComuni/associaImmagineENomeANomeUtente";

function ElencoLavorazioniProdotto({ idLavorazione, utente }) {
  //console.log("ElencoLavorazioniProdotto")

  const [lavorazione, setLavorazione] = useState({
    data: "",
    tipo: "",
    utente: "",
    appunti: "",
  });

  const { pathImmagine, nomeDisplay } = associaImmagineENomeANomeUtente(
    lavorazione.utente,
    utente.username
  );

  useEffect(() => {
    fetch(apiUrl + "/prodotti/get/lavorazione/" + idLavorazione)
      .then((resp) => resp.json())
      .then((data) => setLavorazione(data));
  }, []);

  return (
    <div className="flex items-center pr3">
      <div className="pa1 tc" style={{ flexShrink: 0 }}>
        <img
          src={pathImmagine}
          alt={nomeDisplay}
          className="br-100 dib mr3"
          style={{
            width: "60px",
            height: "60px",
            minWidth: "60px",
            minHeight: "60px",
            objectFit: "cover",
            display: "block",
          }}
        ></img>
      </div>

      <div className="">
        {lavorazione.data !== "" && (
          <p>Data: {umanizzaDataSenzaSecondi(lavorazione.data)}</p>
        )}
        {lavorazione.tipo !== "" && <p>Tipo: {lavorazione.tipo}</p>}
        {lavorazione.utente !== "" && <p>Utente: {nomeDisplay}</p>}
        {lavorazione.appunti !== "" && (
          <p>
            Appunti: <strong>{lavorazione.appunti}</strong>
          </p>
        )}
        <hr></hr>
      </div>
    </div>
  );
}

export default ElencoLavorazioniProdotto;
